import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import useFetchData from "../../../../../hooks/useFetchData";
import { DEFAULT_ATTACHED_DOCUMENTS_AND_PHOTOS_STATE } from "../constants";
import { useStateIfMounted } from "use-state-if-mounted";

export const useAttachedDocumentsAndPhotos = (selectedWell) => {
  const { getAccessTokenSilently } = useAuth0();

  const [editorState, setEditorState] = useStateIfMounted(
    DEFAULT_ATTACHED_DOCUMENTS_AND_PHOTOS_STATE
  );

  const handleUpdateState = (name, value) => {
    setEditorState((prevState) => {
      let newFilterValues = { ...prevState };
      newFilterValues[name] = value;
      return newFilterValues;
    });
  };

  const { data, isFetching, error, refetch } = useQuery(
    ["assoc-wells-to-attachments", selectedWell],
    async () => {
      if (!selectedWell) {
        setEditorState(DEFAULT_ATTACHED_DOCUMENTS_AND_PHOTOS_STATE);
        return [];
      }
      try {
        const token = await getAccessTokenSilently();
        const headers = { Authorization: `Bearer ${token}` };

        const { data } = await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/assoc-wells-to-attachments/${selectedWell}`,
          { headers }
        );
        setEditorState(DEFAULT_ATTACHED_DOCUMENTS_AND_PHOTOS_STATE);
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    {
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
    }
  );

  const [attachmentTagsLookup] = useFetchData(
    "ui-list-wm-attachment-tags",
    [],
    true
  );

  return {
    data,
    isLoading: isFetching,
    error,
    refetch,
    lookups: {
      attachmentTags: attachmentTagsLookup,
    },
    state: editorState,
    setter: setEditorState,
    handleUpdateState,
  };
};
